import React, { useEffect, useState } from "react";
import { CCollapse, CLink } from "@coreui/react";
import { Formik, Form, Field } from "formik";
import config from "../../config/config";
import axios from "axios";

import { toastError, toastSuccess } from "../../common/Toast";
import { SUCCESS_MESSAGE, ERROR_MESSAGE } from "../../common/Constant";
import Loader from "../Loader/Loader";

const Receipt = (props) => {
  const [visibleReceipt, setVisibleReceipt] = useState(false);
  const [comingReceipt, setcomingReceipt] = useState(
    props.visibleReceiptChange
  );
  const [formValues, setFormValues] = useState({
    OverrideReceiptTitle: "",
    EmailReceiptSubject: "",
    ShowItemIdOnReceipt: false,
    ShowImagesOnReceipt: false,
    MaxWidthOfItemImagesOnReceipt: "",
    ShowPersonIDOnReceipt: false,
    ShowItemTagsOnFulfillmentSheet: false,
    ShowTotalOnFulfillmentSheet: false,
    ShowTaxableAndNonTaxableSummaryOnReceipt: false,
    OverrideSymbolForTaxableSummaryOnReceipt: "",
    OverrideSymbolForNonTaxableSummaryOnReceipt: "",
    ShowTaxDetailsOnReceipt: false,
    SecondLanguageOnReceipts: "",
    UppercaseReceiptText: false,
    ShowItemKitItemsOnReceipt: false,
    ShowTotalDiscountOnReceipt: false,
    HidePricesOnFulfillmentSheet: false,
    ShowItemIdOnReceiving: false,
    HideALLPricesOnReceiving: false,
    NumberOfDecimalsForQuantityOnReceipt: "",
    IndicateTaxableOnReceipt: false,
    IndicateNonTaxableOnReceipt: false,
    OverrideSymbolForNonTaxable: "",
    ShowTaxPerItemOnReceipt: false,
    HideDescriptionOnReceipt: false,
    HideMerchantIDFromReceipt: false,
    HideDescriptionOnEMailedReceipts: false,
    HideDescriptionOnSalesAndReceivingsInterfaces: false,
    HideItemDescriptionOnSuspendedSales: false,
    ShowOriginalPriceOnReceiptIfMarkedDown: false,
    PrintReceiptAfterSale: false,
    WidePrinterReceiptFormat: false,
    PrintReceiptAfterReceiving: false,
    HideSignature: false,
    DisableSignatureCaptureForPHPPOSCreditCardProcessing: false,
    AutoCaptureSignature: false,
    RemoveCustomerNameFromReceipt: false,
    RemoveEmployeeLastNameFromReceipt: "",
    RemoveEmployeeNameFromReceipt: "",
    RemoveCustomerCompanyNameFromReceipt: false,
    RemoveCustomerContactInfoFromReceip: false,
    HideEMailOnReceipt: false,
    SortReceiptColumn: "",
    AutomaticallyEmailReceipt: false,
    AutomaticallySMSReceipt: false,
    AutomaticallyPrintDuplicateReceiptForCreditCardTransactions: false,
    AlwaysPrintDuplicateReceiptForAllTransactions: false,
    AutomaticallyShowCommentsOnReceipt: false,
    HideBarcodeOnReceipts: false,
    GroupAllTaxesOnReceipt: false,
    RedirectToSaleOrReceivingScreenAfterPrintingReceipt: false,
    ReceiptTextSize: "",
    HideStoreAccountBalanceOnReceipt: false,
    RoundToNearest05OnReceipt: false,
    ReturnPolicy: "",
    AnnouncementsSpecials: "",
    EnablePDFReceipts: false,
    PDFReceiptMessageInEmailBody: "",
    ShowSignatureOnReceivingReceipt: false,
    OverrideSignatureText: "",
    HideCategoriesOnReceivingsGrid: false,
    HideTagsOnReceivingsGrid: false,
    HideSuppliersOnReceivingsGrid: false,
    HideFavoritesOnReceivingsGrid: false,
    ReceiptDownloadFilenamePrefix: "",
    CaptureInternalNotesDuringReceiving: false,
    DisableVariationPopupInReceiving: false,
    HideLocationNameOnReceipt: false,
    AllowReorderOnSalesReceipt: false,
    AllowReorderOnReceivingReceipt: false,
  });

  const [loading, setLoading] = useState(false);
  const [indicateNonTaxableOnReceipt, setIndicateNonTaxableOnReceipt] =
    useState(false);
  const [
    showTaxableAndNonTaxableSummaryOnReceipt,
    setShowTaxableAndNonTaxableSummaryOnReceipt,
  ] = useState(false);

  const token = localStorage.getItem("Token");

  const handleIndicateNonTaxableOnReceipt = () => {
    setIndicateNonTaxableOnReceipt(!indicateNonTaxableOnReceipt);
  };

  const handleShowTaxableAndNonTaxableSummaryOnReceipt = () => {
    setShowTaxableAndNonTaxableSummaryOnReceipt(
      !showTaxableAndNonTaxableSummaryOnReceipt
    );
  };

  const handleSubmit = (values) => {
    const formArray = [
      {
        AppConfigkey: "OverrideReceiptTitle",
        AppConfigvalue: values.OverrideReceiptTitle,
      },
      {
        AppConfigkey: "EmailReceiptSubject",
        AppConfigvalue: values.EmailReceiptSubject,
      },
      {
        AppConfigkey: "ShowItemIdOnReceipt",
        AppConfigvalue: values.ShowItemIdOnReceipt,
      },
      {
        AppConfigkey: "ShowImagesOnReceipt",
        AppConfigvalue: values.ShowImagesOnReceipt,
      },
      {
        AppConfigkey: "MaxWidthOfItemImagesOnReceipt",
        AppConfigvalue: values.MaxWidthOfItemImagesOnReceipt,
      },
      {
        AppConfigkey: "ShowPersonIDOnReceipt",
        AppConfigvalue: values.ShowPersonIDOnReceipt,
      },
      {
        AppConfigkey: "ShowItemTagsOnFulfillmentSheet",
        AppConfigvalue: values.ShowItemTagsOnFulfillmentSheet,
      },
      {
        AppConfigkey: "ShowTotalOnFulfillmentSheet",
        AppConfigvalue: values.ShowTotalOnFulfillmentSheet,
      },
      {
        AppConfigkey: "ShowTaxableAndNonTaxableSummaryOnReceipt",
        AppConfigvalue: values.ShowTaxableAndNonTaxableSummaryOnReceipt,
      },
      {
        AppConfigkey: "OverrideSymbolForTaxableSummaryOnReceipt",
        AppConfigvalue: values.OverrideSymbolForTaxableSummaryOnReceipt,
      },
      {
        AppConfigkey: "OverrideSymbolForNonTaxableSummaryOnReceipt",
        AppConfigvalue: values.OverrideSymbolForNonTaxableSummaryOnReceipt,
      },
      {
        AppConfigkey: "ShowTaxDetailsOnReceipt",
        AppConfigvalue: values.ShowTaxDetailsOnReceipt,
      },
      {
        AppConfigkey: "SecondLanguageOnReceipts",
        AppConfigvalue: values.SecondLanguageOnReceipts,
      },
      {
        AppConfigkey: "UppercaseReceiptText",
        AppConfigvalue: values.UppercaseReceiptText,
      },
      {
        AppConfigkey: "ShowItemKitItemsOnReceipt",
        AppConfigvalue: values.ShowItemKitItemsOnReceipt,
      },
      {
        AppConfigkey: "ShowTotalDiscountOnReceipt",
        AppConfigvalue: values.ShowTotalDiscountOnReceipt,
      },
      {
        AppConfigkey: "HidePricesOnFulfillmentSheet",
        AppConfigvalue: values.HidePricesOnFulfillmentSheet,
      },
      {
        AppConfigkey: "ShowItemIdOnReceiving",
        AppConfigvalue: values.ShowItemIdOnReceiving,
      },
      {
        AppConfigkey: "HideALLPricesOnReceiving",
        AppConfigvalue: values.HideALLPricesOnReceiving,
      },
      {
        AppConfigkey: "NumberOfDecimalsForQuantityOnReceipt",
        AppConfigvalue: values.NumberOfDecimalsForQuantityOnReceipt,
      },
      {
        AppConfigkey: "IndicateTaxableOnReceipt",
        AppConfigvalue: values.IndicateTaxableOnReceipt,
      },
      {
        AppConfigkey: "IndicateNonTaxableOnReceipt",
        AppConfigvalue: values.IndicateNonTaxableOnReceipt,
      },
      {
        AppConfigkey: "OverrideSymbolForNonTaxable",
        AppConfigvalue: values.OverrideSymbolForNonTaxable,
      },
      {
        AppConfigkey: "ShowTaxPerItemOnReceipt",
        AppConfigvalue: values.ShowTaxPerItemOnReceipt,
      },
      {
        AppConfigkey: "HideDescriptionOnReceipt",
        AppConfigvalue: values.HideDescriptionOnReceipt,
      },
      {
        AppConfigkey: "HideMerchantIDFromReceipt",
        AppConfigvalue: values.HideMerchantIDFromReceipt,
      },
      {
        AppConfigkey: "HideDescriptionOnEMailedReceipts",
        AppConfigvalue: values.HideDescriptionOnEMailedReceipts,
      },
      {
        AppConfigkey: "HideDescriptionOnSalesAndReceivingsInterfaces",
        AppConfigvalue: values.HideDescriptionOnSalesAndReceivingsInterfaces,
      },
      {
        AppConfigkey: "HideItemDescriptionOnSuspendedSales",
        AppConfigvalue: values.HideItemDescriptionOnSuspendedSales,
      },
      {
        AppConfigkey: "ShowOriginalPriceOnReceiptIfMarkedDown",
        AppConfigvalue: values.ShowOriginalPriceOnReceiptIfMarkedDown,
      },
      {
        AppConfigkey: "PrintReceiptAfterSale",
        AppConfigvalue: values.PrintReceiptAfterSale,
      },
      {
        AppConfigkey: "WidePrinterReceiptFormat",
        AppConfigvalue: values.WidePrinterReceiptFormat,
      },
      {
        AppConfigkey: "PrintReceiptAfterReceiving",
        AppConfigvalue: values.PrintReceiptAfterReceiving,
      },
      { AppConfigkey: "HideSignature", AppConfigvalue: values.HideSignature },
      {
        AppConfigkey: "DisableSignatureCaptureForPHPPOSCreditCardProcessing",
        AppConfigvalue:
          values.DisableSignatureCaptureForPHPPOSCreditCardProcessing,
      },
      {
        AppConfigkey: "AutoCaptureSignature",
        AppConfigvalue: values.AutoCaptureSignature,
      },
      {
        AppConfigkey: "RemoveCustomerNameFromReceipt",
        AppConfigvalue: values.RemoveCustomerNameFromReceipt,
      },
      {
        AppConfigkey: "RemoveEmployeeLastNameFromReceipt",
        AppConfigvalue: values.RemoveEmployeeLastNameFromReceipt,
      },
      {
        AppConfigkey: "RemoveEmployeeNameFromReceipt",
        AppConfigvalue: values.RemoveEmployeeNameFromReceipt,
      },
      {
        AppConfigkey: "RemoveCustomerCompanyNameFromReceipt",
        AppConfigvalue: values.RemoveCustomerCompanyNameFromReceipt,
      },
      {
        AppConfigkey: "RemoveCustomerContactInfoFromReceip",
        AppConfigvalue: values.RemoveCustomerContactInfoFromReceip,
      },
      {
        AppConfigkey: "HideEMailOnReceipt",
        AppConfigvalue: values.HideEMailOnReceipt,
      },
      {
        AppConfigkey: "SortReceiptColumn",
        AppConfigvalue: values.SortReceiptColumn,
      },
      {
        AppConfigkey: "AutomaticallyEmailReceipt",
        AppConfigvalue: values.AutomaticallyEmailReceipt,
      },
      {
        AppConfigkey: "AutomaticallySMSReceipt",
        AppConfigvalue: values.AutomaticallySMSReceipt,
      },
      {
        AppConfigkey:
          "AutomaticallyPrintDuplicateReceiptForCreditCardTransactions",
        AppConfigvalue:
          values.AutomaticallyPrintDuplicateReceiptForCreditCardTransactions,
      },
      {
        AppConfigkey: "AlwaysPrintDuplicateReceiptForAllTransactions",
        AppConfigvalue: values.AlwaysPrintDuplicateReceiptForAllTransactions,
      },
      {
        AppConfigkey: "AutomaticallyShowCommentsOnReceipt",
        AppConfigvalue: values.AutomaticallyShowCommentsOnReceipt,
      },
      {
        AppConfigkey: "HideBarcodeOnReceipts",
        AppConfigvalue: values.HideBarcodeOnReceipts,
      },
      {
        AppConfigkey: "GroupAllTaxesOnReceipt",
        AppConfigvalue: values.GroupAllTaxesOnReceipt,
      },
      {
        AppConfigkey: "RedirectToSaleOrReceivingScreenAfterPrintingReceipt",
        AppConfigvalue:
          values.RedirectToSaleOrReceivingScreenAfterPrintingReceipt,
      },
      {
        AppConfigkey: "ReceiptTextSize",
        AppConfigvalue: values.ReceiptTextSize,
      },
      {
        AppConfigkey: "HideStoreAccountBalanceOnReceipt",
        AppConfigvalue: values.HideStoreAccountBalanceOnReceipt,
      },
      {
        AppConfigkey: "RoundToNearest05OnReceipt",
        AppConfigvalue: values.RoundToNearest05OnReceipt,
      },
      { AppConfigkey: "ReturnPolicy", AppConfigvalue: values.ReturnPolicy },
      {
        AppConfigkey: "AnnouncementsSpecials",
        AppConfigvalue: values.AnnouncementsSpecials,
      },
      {
        AppConfigkey: "EnablePDFReceipts",
        AppConfigvalue: values.EnablePDFReceipts,
      },
      {
        AppConfigkey: "PDFReceiptMessageInEmailBody",
        AppConfigvalue: values.PDFReceiptMessageInEmailBody,
      },
      {
        AppConfigkey: "ShowSignatureOnReceivingReceipt",
        AppConfigvalue: values.ShowSignatureOnReceivingReceipt,
      },
      {
        AppConfigkey: "OverrideSignatureText",
        AppConfigvalue: values.OverrideSignatureText,
      },
      {
        AppConfigkey: "HideCategoriesOnReceivingsGrid",
        AppConfigvalue: values.HideCategoriesOnReceivingsGrid,
      },
      {
        AppConfigkey: "HideTagsOnReceivingsGrid",
        AppConfigvalue: values.HideTagsOnReceivingsGrid,
      },
      {
        AppConfigkey: "HideSuppliersOnReceivingsGrid",
        AppConfigvalue: values.HideSuppliersOnReceivingsGrid,
      },
      {
        AppConfigkey: "HideFavoritesOnReceivingsGrid",
        AppConfigvalue: values.HideFavoritesOnReceivingsGrid,
      },
      {
        AppConfigkey: "ReceiptDownloadFilenamePrefix",
        AppConfigvalue: values.ReceiptDownloadFilenamePrefix,
      },
      {
        AppConfigkey: "CaptureInternalNotesDuringReceiving",
        AppConfigvalue: values.CaptureInternalNotesDuringReceiving,
      },
      {
        AppConfigkey: "DisableVariationPopupInReceiving",
        AppConfigvalue: values.DisableVariationPopupInReceiving,
      },
      {
        AppConfigkey: "HideLocationNameOnReceipt",
        AppConfigvalue: values.HideLocationNameOnReceipt,
      },
      {
        AppConfigkey: "AllowReorderOnSalesReceipt",
        AppConfigvalue: values.AllowReorderOnSalesReceipt,
      },
      {
        AppConfigkey: "AllowReorderOnReceivingReceipt",
        AppConfigvalue: values.AllowReorderOnReceivingReceipt,
      },
    ];

    const jsonobj = {};
    jsonobj.StoreConfig = formArray;

    let jsonstring = JSON.stringify(jsonobj);

    setLoading(true);

    axios
      .post(
        `${config.storeConfigBaseUrl}/storeconfig/upsert`,
        {
          type: "RECEIPT",
          storeconfigxml: jsonstring,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS" && res.data.ResponseID > 0) {
          toastSuccess(SUCCESS_MESSAGE);
        } else {
          toastError(ERROR_MESSAGE);
        }

        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    setLoading(true);

    axios
      .get(
        `${config.storeConfigBaseUrl}/storeconfig/getallconfig?type=RECEIPT`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((response) => {
        const responseData = response.data.ResponseData;

        responseData.map((data) => {
          if (data.AppConfigkey === "OverrideReceiptTitle") {
            formValues.OverrideReceiptTitle = data.AppConfigvalue;
          } else if (data.AppConfigkey === "EmailReceiptSubject") {
            formValues.EmailReceiptSubject = data.AppConfigvalue;
          } else if (data.AppConfigkey === "ShowItemIdOnReceipt") {
            formValues.ShowItemIdOnReceipt =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "ShowImagesOnReceipt") {
            formValues.ShowImagesOnReceipt =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "MaxWidthOfItemImagesOnReceipt") {
            formValues.MaxWidthOfItemImagesOnReceipt = data.AppConfigvalue;
          } else if (data.AppConfigkey === "ShowPersonIDOnReceipt") {
            formValues.ShowPersonIDOnReceipt =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "ShowItemTagsOnFulfillmentSheet") {
            formValues.ShowItemTagsOnFulfillmentSheet =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "ShowTotalOnFulfillmentSheet") {
            formValues.ShowTotalOnFulfillmentSheet =
              data.AppConfigvalue === "false" ? false : true;
          } else if (
            data.AppConfigkey === "ShowTaxableAndNonTaxableSummaryOnReceipt"
          ) {
            formValues.ShowTaxableAndNonTaxableSummaryOnReceipt =
              data.AppConfigvalue === "false" ? false : true;
          } else if (
            data.AppConfigkey === "OverrideSymbolForTaxableSummaryOnReceipt"
          ) {
            formValues.OverrideSymbolForTaxableSummaryOnReceipt =
              data.AppConfigvalue;
          } else if (
            data.AppConfigkey === "OverrideSymbolForNonTaxableSummaryOnReceipt"
          ) {
            formValues.OverrideSymbolForNonTaxableSummaryOnReceipt =
              data.AppConfigvalue;
          } else if (data.AppConfigkey === "ShowTaxDetailsOnReceipt") {
            formValues.ShowTaxDetailsOnReceipt =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "SecondLanguageOnReceipts") {
            formValues.SecondLanguageOnReceipts = data.AppConfigvalue;
          } else if (data.AppConfigkey === "UppercaseReceiptText") {
            formValues.UppercaseReceiptText =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "ShowItemKitItemsOnReceipt") {
            formValues.ShowItemKitItemsOnReceipt =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "ShowTotalDiscountOnReceipt") {
            formValues.ShowTotalDiscountOnReceipt =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "HidePricesOnFulfillmentSheet") {
            formValues.HidePricesOnFulfillmentSheet =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "ShowItemIdOnReceiving") {
            formValues.ShowItemIdOnReceiving =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "HideALLPricesOnReceiving") {
            formValues.HideALLPricesOnReceiving =
              data.AppConfigvalue === "false" ? false : true;
          } else if (
            data.AppConfigkey === "NumberOfDecimalsForQuantityOnReceipt"
          ) {
            formValues.NumberOfDecimalsForQuantityOnReceipt =
              data.AppConfigvalue;
          } else if (data.AppConfigkey === "IndicateTaxableOnReceipt") {
            formValues.IndicateTaxableOnReceipt =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "IndicateNonTaxableOnReceipt") {
            formValues.IndicateNonTaxableOnReceipt =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "OverrideSymbolForNonTaxable") {
            formValues.OverrideSymbolForNonTaxable = data.AppConfigvalue;
          } else if (data.AppConfigkey === "ShowTaxPerItemOnReceipt") {
            formValues.ShowTaxPerItemOnReceipt =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "HideDescriptionOnReceipt") {
            formValues.HideDescriptionOnReceipt =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "HideMerchantIDFromReceipt") {
            formValues.HideMerchantIDFromReceipt =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "HideDescriptionOnEMailedReceipts") {
            formValues.HideDescriptionOnEMailedReceipts =
              data.AppConfigvalue === "false" ? false : true;
          } else if (
            data.AppConfigkey ===
            "HideDescriptionOnSalesAndReceivingsInterfaces"
          ) {
            formValues.HideDescriptionOnSalesAndReceivingsInterfaces =
              data.AppConfigvalue === "false" ? false : true;
          } else if (
            data.AppConfigkey === "HideItemDescriptionOnSuspendedSales"
          ) {
            formValues.HideItemDescriptionOnSuspendedSales =
              data.AppConfigvalue === "false" ? false : true;
          } else if (
            data.AppConfigkey === "ShowOriginalPriceOnReceiptIfMarkedDown"
          ) {
            formValues.ShowOriginalPriceOnReceiptIfMarkedDown =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "PrintReceiptAfterSale") {
            formValues.PrintReceiptAfterSale =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "WidePrinterReceiptFormat") {
            formValues.WidePrinterReceiptFormat =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "PrintReceiptAfterReceiving") {
            formValues.PrintReceiptAfterReceiving =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "HideSignature") {
            formValues.HideSignature =
              data.AppConfigvalue === "false" ? false : true;
          } else if (
            data.AppConfigkey ===
            "DisableSignatureCaptureForPHPPOSCreditCardProcessing"
          ) {
            formValues.DisableSignatureCaptureForPHPPOSCreditCardProcessing =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "AutoCaptureSignature") {
            formValues.AutoCaptureSignature =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "RemoveCustomerNameFromReceipt") {
            formValues.RemoveCustomerNameFromReceipt =
              data.AppConfigvalue === "false" ? false : true;
          } else if (
            data.AppConfigkey === "RemoveEmployeeLastNameFromReceipt"
          ) {
            formValues.RemoveEmployeeLastNameFromReceipt = data.AppConfigvalue;
          } else if (data.AppConfigkey === "RemoveEmployeeNameFromReceipt") {
            formValues.RemoveEmployeeNameFromReceipt =
              data.AppConfigvalue === "false" ? false : true;
          } else if (
            data.AppConfigkey === "RemoveCustomerCompanyNameFromReceipt"
          ) {
            formValues.RemoveCustomerCompanyNameFromReceipt =
              data.AppConfigvalue === "false" ? false : true;
          } else if (
            data.AppConfigkey === "RemoveCustomerContactInfoFromReceip"
          ) {
            formValues.RemoveCustomerContactInfoFromReceip =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "HideEMailOnReceipt") {
            formValues.HideEMailOnReceipt =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "SortReceiptColumn") {
            formValues.SortReceiptColumn = data.AppConfigvalue;
          } else if (data.AppConfigkey === "AutomaticallyEmailReceipt") {
            formValues.AutomaticallyEmailReceipt =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "AutomaticallySMSReceipt") {
            formValues.AutomaticallySMSReceipt =
              data.AppConfigvalue === "false" ? false : true;
          } else if (
            data.AppConfigkey ===
            "AutomaticallyPrintDuplicateReceiptForCreditCardTransactions"
          ) {
            formValues.AutomaticallyPrintDuplicateReceiptForCreditCardTransactions =
              data.AppConfigvalue === "false" ? false : true;
          } else if (
            data.AppConfigkey ===
            "AlwaysPrintDuplicateReceiptForAllTransactions"
          ) {
            formValues.AlwaysPrintDuplicateReceiptForAllTransactions =
              data.AppConfigvalue === "false" ? false : true;
          } else if (
            data.AppConfigkey === "AutomaticallyShowCommentsOnReceipt"
          ) {
            formValues.AutomaticallyShowCommentsOnReceipt =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "HideBarcodeOnReceipts") {
            formValues.HideBarcodeOnReceipts =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "GroupAllTaxesOnReceipt") {
            formValues.GroupAllTaxesOnReceipt =
              data.AppConfigvalue === "false" ? false : true;
          } else if (
            data.AppConfigkey ===
            "RedirectToSaleOrReceivingScreenAfterPrintingReceipt"
          ) {
            formValues.RedirectToSaleOrReceivingScreenAfterPrintingReceipt =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "ReceiptTextSize") {
            formValues.ReceiptTextSize = data.AppConfigvalue;
          } else if (data.AppConfigkey === "HideStoreAccountBalanceOnReceipt") {
            formValues.HideStoreAccountBalanceOnReceipt =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "RoundToNearest05OnReceipt") {
            formValues.RoundToNearest05OnReceipt =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "ReturnPolicy") {
            formValues.ReturnPolicy = data.AppConfigvalue;
          } else if (data.AppConfigkey === "AnnouncementsSpecials") {
            formValues.AnnouncementsSpecials = data.AppConfigvalue;
          } else if (data.AppConfigkey === "EnablePDFReceipts") {
            formValues.EnablePDFReceipts =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "PDFReceiptMessageInEmailBody") {
            formValues.PDFReceiptMessageInEmailBody = data.AppConfigvalue;
          } else if (data.AppConfigkey === "ShowSignatureOnReceivingReceipt") {
            formValues.ShowSignatureOnReceivingReceipt =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "OverrideSignatureText") {
            formValues.OverrideSignatureText = data.AppConfigvalue;
          } else if (data.AppConfigkey === "HideCategoriesOnReceivingsGrid") {
            formValues.HideCategoriesOnReceivingsGrid =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "HideTagsOnReceivingsGrid") {
            formValues.HideTagsOnReceivingsGrid =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "HideSuppliersOnReceivingsGrid") {
            formValues.HideSuppliersOnReceivingsGrid =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "HideFavoritesOnReceivingsGrid") {
            formValues.HideFavoritesOnReceivingsGrid =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "ReceiptDownloadFilenamePrefix") {
            formValues.ReceiptDownloadFilenamePrefix = data.AppConfigvalue;
          } else if (
            data.AppConfigkey === "CaptureInternalNotesDuringReceiving"
          ) {
            formValues.CaptureInternalNotesDuringReceiving =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "DisableVariationPopupInReceiving") {
            formValues.DisableVariationPopupInReceiving =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "HideLocationNameOnReceipt") {
            formValues.HideLocationNameOnReceipt =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "AllowReorderOnSalesReceipt") {
            formValues.AllowReorderOnSalesReceipt =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "AllowReorderOnReceivingReceipt") {
            formValues.AllowReorderOnReceivingReceipt =
              data.AppConfigvalue === "false" ? false : true;
          }
        });

        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, []);

  //handleChange
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const fieldValue = type === "checkbox" ? checked : value;

    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: fieldValue,
    }));
  };

  const data = [
    {
      name: "Override Receipt Title:",
      input: (
        <>
          <div className="input-group">
            <Field
              type="text"
              className="form-control"
              id="OverrideReceiptTitle"
              name="OverrideReceiptTitle"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Email Receipt Subject:",
      input: (
        <>
          <div className="input-group">
            <Field
              type="text"
              className="form-control"
              placeholder="Sales Receipt"
              id="EmailReceiptSubject"
              name="EmailReceiptSubject"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Show Item Id On Receipt:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="ShowItemIdOnReceipt"
              name="ShowItemIdOnReceipt"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Show Images On Receipt:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="ShowImagesOnReceipt"
              name="ShowImagesOnReceipt"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Max Width Of Item Images On Receipt (Percentage):",
      input: (
        <>
          <div className="input-group">
            <Field
              as="select"
              className="form-control form-small select"
              id="MaxWidthOfItemImagesOnReceipt"
              name="MaxWidthOfItemImagesOnReceipt"
              onChange={handleChange}
            >
              <option>1%</option>
              <option>2%</option>
              <option>3%</option>
              <option>4%</option>
              <option>5%</option>
              <option>10%</option>
              <option>15%</option>
              <option>20%</option>
              <option>25%</option>
              <option>30%</option>
              <option>35%</option>
              <option>40%</option>
              <option>45%</option>
              <option>50%</option>
              <option>55%</option>
              <option>60%</option>
              <option>65%</option>
              <option>70%</option>
              <option>75%</option>
              <option>80%</option>
              <option>85%</option>
              <option>90%</option>
              <option>95%</option>
              <option>100%</option>
            </Field>
          </div>
        </>
      ),
    },
    {
      name: "Show Person ID On Receipt:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="ShowPersonIDOnReceipt"
              name="ShowPersonIDOnReceipt"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Show Item Tags On Fulfillment Sheet:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="ShowItemTagsOnFulfillmentSheet"
              name="ShowItemTagsOnFulfillmentSheet"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Show Total On Fulfillment Sheet:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="ShowTotalOnFulfillmentSheet"
              name="ShowTotalOnFulfillmentSheet"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Show Taxable And Non Taxable Summary On Receipt:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="ShowTaxableAndNonTaxableSummaryOnReceipt"
              name="ShowTaxableAndNonTaxableSummaryOnReceipt"
              onChange={handleChange}
              onInput={handleShowTaxableAndNonTaxableSummaryOnReceipt}
            />
          </div>
          <div
            className={`form-group row ${
              showTaxableAndNonTaxableSummaryOnReceipt === true ? "" : "d-none"
            }`}
          >
            <label className="col-form-label col-lg-2">
              Override Symbol For Taxable Summary On Receipt:
            </label>
            <div className="col-lg-10">
              <div className="input-group">
                <Field
                  type="text"
                  className="form-control"
                  id="OverrideSymbolForTaxableSummaryOnReceipt"
                  name="OverrideSymbolForTaxableSummaryOnReceipt"
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
          <div
            className={`form-group row ${
              showTaxableAndNonTaxableSummaryOnReceipt === true ? "" : "d-none"
            }`}
          >
            <label className="col-form-label col-lg-2">
              Override Symbol For Non Taxable Summary On Receipt:
            </label>
            <div className="col-lg-10">
              <div className="input-group">
                <Field
                  type="text"
                  className="form-control"
                  id="OverrideSymbolForNonTaxableSummaryOnReceipt"
                  name="OverrideSymbolForNonTaxableSummaryOnReceipt"
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
        </>
      ),
    },
    {
      name: "Show Tax Details On Receipt:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="ShowTaxDetailsOnReceipt"
              name="ShowTaxDetailsOnReceipt"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Second Language On Receipts:",
      input: (
        <>
          <div className="input-group">
            <Field
              as="select"
              className="form-control form-small select"
              id="SecondLanguageOnReceipts"
              name="SecondLanguageOnReceipts"
              onChange={handleChange}
            >
              <option>None</option>
              <option>English</option>
              <option>Indonesia</option>
              <option>Española</option>
              <option>Fançais</option>
              <option>Italiano</option>
              <option>Deutsch</option>
              <option>Nederlands</option>
              <option>Portugues</option>
              <option>العَرَبِيةُ‎‎</option>
              <option>Khmer</option>
              <option>Vietnamese</option>
              <option>中文</option>
              <option>繁體中文</option>
              <option>Tamil</option>
            </Field>
          </div>
        </>
      ),
    },
    {
      name: "Uppercase Receipt Text:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="UppercaseReceiptText"
              name="UppercaseReceiptText"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Show Item Kit Items On Receipt:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="ShowItemKitItemsOnReceipt"
              name="ShowItemKitItemsOnReceipt"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Show Total Discount On Receipt:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="ShowTotalDiscountOnReceipt"
              name="ShowTotalDiscountOnReceipt"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Hide Prices On Fulfillment Sheet:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="HidePricesOnFulfillmentSheet"
              name="HidePricesOnFulfillmentSheet"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Show Item Id On Receiving:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="ShowItemIdOnReceiving"
              name="ShowItemIdOnReceiving"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Hide All Prices On Receiving:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="HideALLPricesOnReceiving"
              name="HideALLPricesOnReceiving"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Number Of Decimals For Quantity On Receipt:",
      input: (
        <>
          <div className="input-group">
            <Field
              as="select"
              className="form-control form-small select"
              id="NumberOfDecimalsForQuantityOnReceipt"
              name="NumberOfDecimalsForQuantityOnReceipt"
              onChange={handleChange}
            >
              <option>Let system decide (Recommended)</option>
              <option>0</option>
              <option>1</option>
              <option>2</option>
              <option>3</option>
              <option>4</option>
              <option>5</option>
              <option>6</option>
              <option>7</option>
              <option>8</option>
              <option>9</option>
              <option>10</option>
            </Field>
          </div>
        </>
      ),
    },
    {
      name: "Indicate Taxable On Receipt:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="IndicateTaxableOnReceipt"
              name="IndicateTaxableOnReceipt"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Indicate Non Taxable On Receipt:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="IndicateNonTaxableOnReceipt"
              name="IndicateNonTaxableOnReceipt"
              onChange={handleChange}
              onInput={handleIndicateNonTaxableOnReceipt}
            />
          </div>
          <div
            className={`form-group row ${
              indicateNonTaxableOnReceipt === true ? "" : "d-none"
            }`}
          >
            <label className="col-form-label col-lg-2">
              Override Symbol For Non Taxable:
            </label>
            <div className="col-lg-10">
              <div className="input-group">
                <Field
                  type="text"
                  className="form-control"
                  id="OverrideSymbolForNonTaxable"
                  name="OverrideSymbolForNonTaxable"
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
        </>
      ),
    },
    {
      name: "Show Tax Per Item On Receipt:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="ShowTaxPerItemOnReceipt"
              name="ShowTaxPerItemOnReceipt"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Hide Description On Receipt:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="HideDescriptionOnReceipt"
              name="HideDescriptionOnReceipt"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Hide Merchant ID From Receipt:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="HideMerchantIDFromReceipt"
              name="HideMerchantIDFromReceipt"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Hide Description On E-Mailed Receipts:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="HideDescriptionOnEMailedReceipts"
              name="HideDescriptionOnEMailedReceipts"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Hide Description On Sales And Receivings Interfaces:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="HideDescriptionOnSalesAndReceivingsInterfaces"
              name="HideDescriptionOnSalesAndReceivingsInterfaces"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Hide Item Description On Suspended Sales:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="HideItemDescriptionOnSuspendedSales"
              name="HideItemDescriptionOnSuspendedSales"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Show Original Price On Receipt If Marked Down:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="ShowOriginalPriceOnReceiptIfMarkedDown"
              name="ShowOriginalPriceOnReceiptIfMarkedDown"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Print Receipt After Sale:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="PrintReceiptAfterSale"
              name="PrintReceiptAfterSale"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Wide Printer Receipt Format:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="WidePrinterReceiptFormat"
              name="WidePrinterReceiptFormat"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Print Receipt After Receiving:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="PrintReceiptAfterReceiving"
              name="PrintReceiptAfterReceiving"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Hide Signature:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="HideSignature"
              name="HideSignature"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Disable Signature Capture For PHP POS Credit Card Processing:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="DisableSignatureCaptureForPHPPOSCreditCardProcessing"
              name="DisableSignatureCaptureForPHPPOSCreditCardProcessing"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Auto Capture Signature:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="AutoCaptureSignature"
              name="AutoCaptureSignature"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Remove Customer Name From Receipt:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="RemoveCustomerNameFromReceipt"
              name="RemoveCustomerNameFromReceipt"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Remove Employee Last Name From Receipt:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="RemoveEmployeeLastNameFromReceipt"
              name="RemoveEmployeeLastNameFromReceipt"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Remove Employee Name From Receipt:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="RemoveEmployeeNameFromReceipt"
              name="RemoveEmployeeNameFromReceipt"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Remove Customer Company Name From Receipt:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="RemoveCustomerCompanyNameFromReceipt"
              name="RemoveCustomerCompanyNameFromReceipt"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Remove Customer Contact Info From Receipt:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="RemoveCustomerContactInfoFromReceip"
              name="RemoveCustomerContactInfoFromReceip"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Hide E-Mail On Receipt:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="HideEMailOnReceipt"
              name="HideEMailOnReceipt"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Sort Receipt Column:",
      input: (
        <>
          <div className="input-group">
            <Field
              as="select"
              className="form-control form-small select"
              id="SortReceiptColumn"
              name="SortReceiptColumn"
              onChange={handleChange}
            >
              <option>Node</option>
              <option>Item Name</option>
              <option>UPC/EAN/ISBN</option>
              <option>Product ID</option>
            </Field>
          </div>
        </>
      ),
    },
    {
      name: "Automatically Email Receipt:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="AutomaticallyEmailReceipt"
              name="AutomaticallyEmailReceipt"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Automatically SMS Receipt:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="AutomaticallySMSReceipt"
              name="AutomaticallySMSReceipt"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Automatically Print Duplicate Receipt For Credit Card Transactions:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="AutomaticallyPrintDuplicateReceiptForCreditCardTransactions"
              name="AutomaticallyPrintDuplicateReceiptForCreditCardTransactions"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Always Print Duplicate Receipt For All Transactions:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="AlwaysPrintDuplicateReceiptForAllTransactions"
              name="AlwaysPrintDuplicateReceiptForAllTransactions"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Automatically Show Comments On Receipt:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="AutomaticallyShowCommentsOnReceipt"
              name="AutomaticallyShowCommentsOnReceipt"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Hide Barcode On Receipts:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="HideBarcodeOnReceipts"
              name="HideBarcodeOnReceipts"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Group All Taxes On Receipt:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="GroupAllTaxesOnReceipt"
              name="GroupAllTaxesOnReceipt"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Redirect To Sale Or Receiving Screen After Printing Receipt:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="RedirectToSaleOrReceivingScreenAfterPrintingReceipt"
              name="RedirectToSaleOrReceivingScreenAfterPrintingReceipt"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Receipt Text Size:",
      input: (
        <>
          <div className="input-group">
            <Field
              as="select"
              className="form-control form-small select"
              id="ReceiptTextSize"
              name="ReceiptTextSize"
              onChange={handleChange}
            >
              <option>Small</option>
              <option>Medium</option>
              <option>Large</option>
              <option>Extra Large</option>
            </Field>
          </div>
        </>
      ),
    },
    {
      name: "Hide Store Account Balance On Receipt:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="HideStoreAccountBalanceOnReceipt"
              name="HideStoreAccountBalanceOnReceipt"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Round To Nearest .05 On Receipt:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="RoundToNearest05OnReceipt"
              name="RoundToNearest05OnReceipt"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Return Policy:",
      input: (
        <>
          <div className="input-group">
            <Field
              as="textarea"
              className="form-control"
              rows={3}
              id="ReturnPolicy"
              name="ReturnPolicy"
              onChange={handleChange}
            ></Field>
          </div>
        </>
      ),
    },
    {
      name: "Announcements/Specials:",
      input: (
        <>
          <div className="input-group">
            <Field
              as="textarea"
              type="text"
              className="form-control"
              rows={3}
              id="AnnouncementsSpecials"
              name="AnnouncementsSpecials"
              onChange={handleChange}
            ></Field>
          </div>
        </>
      ),
    },
    {
      name: "Enable PDF Receipts:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="EnablePDFReceipts"
              name="EnablePDFReceipts"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "PDF Receipt Message In Email Body:",
      input: (
        <>
          <div className="input-group">
            <Field
              as="textarea"
              type="text"
              className="form-control"
              rows={3}
              id="PDFReceiptMessageInEmailBody"
              name="PDFReceiptMessageInEmailBody"
              onChange={handleChange}
            ></Field>
          </div>
        </>
      ),
    },
    {
      name: "Show Signature On Receiving Receipt:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="ShowSignatureOnReceivingReceipt"
              name="ShowSignatureOnReceivingReceipt"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Override Signature Text:",
      input: (
        <>
          <div className="input-group">
            <Field
              as="textarea"
              type="text"
              className="form-control"
              rows={3}
              id="OverrideSignatureText"
              name="OverrideSignatureText"
              onChange={handleChange}
            ></Field>
          </div>
        </>
      ),
    },
    {
      name: "Hide Categories On Receivings Grid:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="HideCategoriesOnReceivingsGrid"
              name="HideCategoriesOnReceivingsGrid"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Hide Tags On Receivings Grid:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="HideTagsOnReceivingsGrid"
              name="HideTagsOnReceivingsGrid"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Hide Suppliers On Receivings Grid:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="HideSuppliersOnReceivingsGrid"
              name="HideSuppliersOnReceivingsGrid"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Hide Favorites On Receivings Grid:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="HideFavoritesOnReceivingsGrid"
              name="HideFavoritesOnReceivingsGrid"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Receipt Download Filename Prefix:",
      input: (
        <>
          <div className="input-group">
            <Field
              type="text"
              className="form-control"
              id="ReceiptDownloadFilenamePrefix"
              name="ReceiptDownloadFilenamePrefix"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Capture Internal Notes During Receiving:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="CaptureInternalNotesDuringReceiving"
              name="CaptureInternalNotesDuringReceiving"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Disable Variation Popup In Receiving:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="DisableVariationPopupInReceiving"
              name="DisableVariationPopupInReceiving"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Hide Location Name On Receipt:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="HideLocationNameOnReceipt"
              name="HideLocationNameOnReceipt"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Allow Reorder On Sales Receipt:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="AllowReorderOnSalesReceipt"
              name="AllowReorderOnSalesReceipt"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Allow Reorder On Receiving Receipt:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="AllowReorderOnReceivingReceipt"
              name="AllowReorderOnReceivingReceipt"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
  ];

  const matchesSearchQuery = data.filter((el) => {
    return el.name.toLowerCase().includes(props.searchQuery.toLowerCase());
  });

  return (
    <>
      {/*  */}
      {/* <Loader loading={loading} /> */}
      {matchesSearchQuery.length === data.length ? (
        <div className="card">
          <div
            style={{ padding: "0px", marginTop: "16px", marginLeft: "18px" }}
            className="card-header"
          >
            <h5 className="card-title">
              <CLink
                style={{ color: "var(--primary-main-color)" }}
                onClick={() => {
                  setVisibleReceipt(!visibleReceipt);
                  setcomingReceipt(!!comingReceipt);
                }}
              >
                Receipt
              </CLink>
            </h5>
          </div>
          <CCollapse visible={visibleReceipt || props.visibleReceiptChange}>
            <div className="card-body">
              <Formik
                {...props}
                initialValues={formValues}
                onSubmit={handleSubmit}
                enableReinitialize
              >
                {({ handleChange }) => (
                  <Form>
                    <div
                      style={{
                        display: "flex",
                        width: "70%",
                        flexDirection: "column",
                        alignItems: "flex-start",
                      }}
                    >
                      {matchesSearchQuery &&
                        matchesSearchQuery?.map((el) => (
                          <div
                            style={{
                              width: "100%",
                              display: "flex",
                              justifyContent: "space-between",
                              marginTop: "10px",
                            }}
                          >
                            <label
                              className="col-form-label"
                              style={{ fontSize: "15px" }}
                            >
                              {el.name}
                            </label>
                            <div style={{ width: "53%" }}>{el.input}</div>
                          </div>
                        ))}
                    </div>
                    {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2">
                        Override Receipt Title:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            type="text"
                            className="form-control"
                            id="OverrideReceiptTitle"
                            name="OverrideReceiptTitle"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2">
                        Email Receipt Subject:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            type="text"
                            className="form-control"
                            placeholder="Sales Receipt"
                            id="EmailReceiptSubject"
                            name="EmailReceiptSubject"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Show Item Id On Receipt:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="ShowItemIdOnReceipt"
                            name="ShowItemIdOnReceipt"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Show Images On Receipt:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="ShowImagesOnReceipt"
                            name="ShowImagesOnReceipt"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2">
                        Max Width Of Item Images On Receipt (Percentage):
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            as="select"
                            className="form-control form-small select"
                            id="MaxWidthOfItemImagesOnReceipt"
                            name="MaxWidthOfItemImagesOnReceipt"
                            onChange={handleChange}
                          >
                            <option>1%</option>
                            <option>2%</option>
                            <option>3%</option>
                            <option>4%</option>
                            <option>5%</option>
                            <option>10%</option>
                            <option>15%</option>
                            <option>20%</option>
                            <option>25%</option>
                            <option>30%</option>
                            <option>35%</option>
                            <option>40%</option>
                            <option>45%</option>
                            <option>50%</option>
                            <option>55%</option>
                            <option>60%</option>
                            <option>65%</option>
                            <option>70%</option>
                            <option>75%</option>
                            <option>80%</option>
                            <option>85%</option>
                            <option>90%</option>
                            <option>95%</option>
                            <option>100%</option>
                          </Field>
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Show Person ID On Receipt:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="ShowPersonIDOnReceipt"
                            name="ShowPersonIDOnReceipt"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Show Item Tags On Fulfillment Sheet:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="ShowItemTagsOnFulfillmentSheet"
                            name="ShowItemTagsOnFulfillmentSheet"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Show Total On Fulfillment Sheet:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="ShowTotalOnFulfillmentSheet"
                            name="ShowTotalOnFulfillmentSheet"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Show Taxable And Non Taxable Summary On Receipt:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="ShowTaxableAndNonTaxableSummaryOnReceipt"
                            name="ShowTaxableAndNonTaxableSummaryOnReceipt"
                            onChange={handleChange}
                            onInput={
                              handleShowTaxableAndNonTaxableSummaryOnReceipt
                            }
                          />
                        </div>
                      </div>
                    </div> */}
                    {/* <div
                      className={`form-group row ${showTaxableAndNonTaxableSummaryOnReceipt === true
                        ? ""
                        : "d-none"
                        }`}
                    >
                      <label className="col-form-label col-lg-2">
                        Override Symbol For Taxable Summary On Receipt:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            type="text"
                            className="form-control"
                            id="OverrideSymbolForTaxableSummaryOnReceipt"
                            name="OverrideSymbolForTaxableSummaryOnReceipt"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                    {/* <div
                      className={`form-group row ${showTaxableAndNonTaxableSummaryOnReceipt === true
                        ? ""
                        : "d-none"
                        }`}
                    >
                      <label className="col-form-label col-lg-2">
                        Override Symbol For Non Taxable Summary On Receipt:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            type="text"
                            className="form-control"
                            id="OverrideSymbolForNonTaxableSummaryOnReceipt"
                            name="OverrideSymbolForNonTaxableSummaryOnReceipt"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Show Tax Details On Receipt:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="ShowTaxDetailsOnReceipt"
                            name="ShowTaxDetailsOnReceipt"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2">
                        Second Language On Receipts:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            as="select"
                            className="form-control form-small select"
                            id="SecondLanguageOnReceipts"
                            name="SecondLanguageOnReceipts"
                            onChange={handleChange}
                          >
                            <option>None</option>
                            <option>English</option>
                            <option>Indonesia</option>
                            <option>Española</option>
                            <option>Fançais</option>
                            <option>Italiano</option>
                            <option>Deutsch</option>
                            <option>Nederlands</option>
                            <option>Portugues</option>
                            <option>العَرَبِيةُ‎‎</option>
                            <option>Khmer</option>
                            <option>Vietnamese</option>
                            <option>中文</option>
                            <option>繁體中文</option>
                            <option>Tamil</option>
                          </Field>
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Uppercase Receipt Text:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="UppercaseReceiptText"
                            name="UppercaseReceiptText"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Show Item Kit Items On Receipt:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="ShowItemKitItemsOnReceipt"
                            name="ShowItemKitItemsOnReceipt"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Show Total Discount On Receipt:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="ShowTotalDiscountOnReceipt"
                            name="ShowTotalDiscountOnReceipt"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Hide Prices On Fulfillment Sheet:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="HidePricesOnFulfillmentSheet"
                            name="HidePricesOnFulfillmentSheet"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Show Item Id On Receiving:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="ShowItemIdOnReceiving"
                            name="ShowItemIdOnReceiving"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Hide ALL Prices On Receiving:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="HideALLPricesOnReceiving"
                            name="HideALLPricesOnReceiving"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2">
                        Number Of Decimals For Quantity On Receipt:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            as="select"
                            className="form-control form-small select"
                            id="NumberOfDecimalsForQuantityOnReceipt"
                            name="NumberOfDecimalsForQuantityOnReceipt"
                            onChange={handleChange}
                          >
                            <option>Let system decide (Recommended)</option>
                            <option>0</option>
                            <option>1</option>
                            <option>2</option>
                            <option>3</option>
                            <option>4</option>
                            <option>5</option>
                            <option>6</option>
                            <option>7</option>
                            <option>8</option>
                            <option>9</option>
                            <option>10</option>
                          </Field>
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Indicate Taxable On Receipt:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="IndicateTaxableOnReceipt"
                            name="IndicateTaxableOnReceipt"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Indicate Non Taxable On Receipt:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="IndicateNonTaxableOnReceipt"
                            name="IndicateNonTaxableOnReceipt"
                            onChange={handleChange}
                            onInput={handleIndicateNonTaxableOnReceipt}
                          />
                        </div>
                      </div>
                    </div> */}
                    {/* <div
                      className={`form-group row ${indicateNonTaxableOnReceipt === true ? "" : "d-none"
                        }`}
                    >
                      <label className="col-form-label col-lg-2">
                        Override Symbol For Non Taxable:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            type="text"
                            className="form-control"
                            id="OverrideSymbolForNonTaxable"
                            name="OverrideSymbolForNonTaxable"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Show Tax Per Item On Receipt:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="ShowTaxPerItemOnReceipt"
                            name="ShowTaxPerItemOnReceipt"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Hide Description On Receipt:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="HideDescriptionOnReceipt"
                            name="HideDescriptionOnReceipt"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Hide Merchant ID From Receipt:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="HideMerchantIDFromReceipt"
                            name="HideMerchantIDFromReceipt"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Hide Description On E-Mailed Receipts:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="HideDescriptionOnEMailedReceipts"
                            name="HideDescriptionOnEMailedReceipts"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Hide Description On Sales And Receivings Interfaces:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="HideDescriptionOnSalesAndReceivingsInterfaces"
                            name="HideDescriptionOnSalesAndReceivingsInterfaces"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Hide Item Description On Suspended Sales:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="HideItemDescriptionOnSuspendedSales"
                            name="HideItemDescriptionOnSuspendedSales"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Show Original Price On Receipt If Marked Down:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="ShowOriginalPriceOnReceiptIfMarkedDown"
                            name="ShowOriginalPriceOnReceiptIfMarkedDown"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Print Receipt After Sale:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="PrintReceiptAfterSale"
                            name="PrintReceiptAfterSale"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Wide Printer Receipt Format:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="WidePrinterReceiptFormat"
                            name="WidePrinterReceiptFormat"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Print Receipt After Receiving:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="PrintReceiptAfterReceiving"
                            name="PrintReceiptAfterReceiving"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Hide Signature:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="HideSignature"
                            name="HideSignature"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Disable Signature Capture For PHP POS Credit Card
                        Processing:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="DisableSignatureCaptureForPHPPOSCreditCardProcessing"
                            name="DisableSignatureCaptureForPHPPOSCreditCardProcessing"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Auto Capture Signature:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="AutoCaptureSignature"
                            name="AutoCaptureSignature"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Remove Customer Name From Receipt:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="RemoveCustomerNameFromReceipt"
                            name="RemoveCustomerNameFromReceipt"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Remove Employee Last Name From Receipt:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="RemoveEmployeeLastNameFromReceipt"
                            name="RemoveEmployeeLastNameFromReceipt"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Remove Employee Name From Receipt:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="RemoveEmployeeNameFromReceipt"
                            name="RemoveEmployeeNameFromReceipt"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Remove Customer Company Name From Receipt:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="RemoveCustomerCompanyNameFromReceipt"
                            name="RemoveCustomerCompanyNameFromReceipt"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Remove Customer Contact Info From Receipt:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="RemoveCustomerContactInfoFromReceip"
                            name="RemoveCustomerContactInfoFromReceip"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Hide E-Mail On Receipt:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="HideEMailOnReceipt"
                            name="HideEMailOnReceipt"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2">
                        Sort Receipt Column:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            as="select"
                            className="form-control form-small select"
                            id="SortReceiptColumn"
                            name="SortReceiptColumn"
                            onChange={handleChange}
                          >
                            <option>Node</option>
                            <option>Item Name</option>
                            <option>UPC/EAN/ISBN</option>
                            <option>Product ID</option>
                          </Field>
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Automatically Email Receipt:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="AutomaticallyEmailReceipt"
                            name="AutomaticallyEmailReceipt"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Automatically SMS Receipt:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="AutomaticallySMSReceipt"
                            name="AutomaticallySMSReceipt"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Automatically Print Duplicate Receipt For Credit Card
                        Transactions:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="AutomaticallyPrintDuplicateReceiptForCreditCardTransactions"
                            name="AutomaticallyPrintDuplicateReceiptForCreditCardTransactions"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Always Print Duplicate Receipt For All Transactions:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="AlwaysPrintDuplicateReceiptForAllTransactions"
                            name="AlwaysPrintDuplicateReceiptForAllTransactions"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Automatically Show Comments On Receipt:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="AutomaticallyShowCommentsOnReceipt"
                            name="AutomaticallyShowCommentsOnReceipt"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Hide Barcode On Receipts:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="HideBarcodeOnReceipts"
                            name="HideBarcodeOnReceipts"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Group All Taxes On Receipt:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="GroupAllTaxesOnReceipt"
                            name="GroupAllTaxesOnReceipt"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Redirect To Sale Or Receiving Screen After Printing
                        Receipt:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="RedirectToSaleOrReceivingScreenAfterPrintingReceipt"
                            name="RedirectToSaleOrReceivingScreenAfterPrintingReceipt"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2">
                        Receipt Text Size:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            as="select"
                            className="form-control form-small select"
                            id="ReceiptTextSize"
                            name="ReceiptTextSize"
                            onChange={handleChange}
                          >
                            <option>Small</option>
                            <option>Medium</option>
                            <option>Large</option>
                            <option>Extra Large</option>
                          </Field>
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Hide Store Account Balance On Receipt:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="HideStoreAccountBalanceOnReceipt"
                            name="HideStoreAccountBalanceOnReceipt"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Round To Nearest .05 On Receipt:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="RoundToNearest05OnReceipt"
                            name="RoundToNearest05OnReceipt"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2">
                        Return Policy:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            as="textarea"
                            className="form-control"
                            rows={3}
                            id="ReturnPolicy"
                            name="ReturnPolicy"
                            onChange={handleChange}
                          ></Field>
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2">
                        Announcements/Specials:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            as="textarea"
                            type="text"
                            className="form-control"
                            rows={3}
                            id="AnnouncementsSpecials"
                            name="AnnouncementsSpecials"
                            onChange={handleChange}
                          ></Field>
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Enable PDF Receipts:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="EnablePDFReceipts"
                            name="EnablePDFReceipts"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2">
                        PDF Receipt Message In Email Body:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            as="textarea"
                            type="text"
                            className="form-control"
                            rows={3}
                            id="PDFReceiptMessageInEmailBody"
                            name="PDFReceiptMessageInEmailBody"
                            onChange={handleChange}
                          ></Field>
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Show Signature On Receiving Receipt:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="ShowSignatureOnReceivingReceipt"
                            name="ShowSignatureOnReceivingReceipt"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2">
                        Override Signature Text:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            as="textarea"
                            type="text"
                            className="form-control"
                            rows={3}
                            id="OverrideSignatureText"
                            name="OverrideSignatureText"
                            onChange={handleChange}
                          ></Field>
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Hide Categories On Receivings Grid:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="HideCategoriesOnReceivingsGrid"
                            name="HideCategoriesOnReceivingsGrid"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Hide Tags On Receivings Grid:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="HideTagsOnReceivingsGrid"
                            name="HideTagsOnReceivingsGrid"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Hide Suppliers On Receivings Grid:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="HideSuppliersOnReceivingsGrid"
                            name="HideSuppliersOnReceivingsGrid"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Hide Favorites On Receivings Grid:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="HideFavoritesOnReceivingsGrid"
                            name="HideFavoritesOnReceivingsGrid"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2">
                        Receipt Download Filename Prefix:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            type="text"
                            className="form-control"
                            id="ReceiptDownloadFilenamePrefix"
                            name="ReceiptDownloadFilenamePrefix"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Capture Internal Notes During Receiving:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="CaptureInternalNotesDuringReceiving"
                            name="CaptureInternalNotesDuringReceiving"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Disable Variation Popup In Receiving:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="DisableVariationPopupInReceiving"
                            name="DisableVariationPopupInReceiving"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Hide Location Name On Receipt:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="HideLocationNameOnReceipt"
                            name="HideLocationNameOnReceipt"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Allow Reorder On Sales Receipt:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="AllowReorderOnSalesReceipt"
                            name="AllowReorderOnSalesReceipt"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Allow Reorder On Receiving Receipt:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="AllowReorderOnReceivingReceipt"
                            name="AllowReorderOnReceivingReceipt"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                    <button
                      type="submit"
                      className="btn btn-primary pull-right mb-3"
                    >
                      Save
                    </button>
                  </Form>
                )}
              </Formik>
            </div>
          </CCollapse>
        </div>
      ) : (
        matchesSearchQuery.length !== 0 && (
          <div className="card">
            <div className="card-header">
              <h5 className="card-title">
                <CLink
                  onClick={() => {
                    setVisibleReceipt(!visibleReceipt);
                    setcomingReceipt(!!comingReceipt);
                  }}
                >
                  Receipt
                </CLink>
              </h5>
            </div>
            <CCollapse visible={visibleReceipt || props.visibleReceiptChange}>
              <div className="card-body">
                <Formik
                  {...props}
                  initialValues={formValues}
                  onSubmit={handleSubmit}
                  enableReinitialize
                >
                  {({ handleChange }) => (
                    <Form>
                      <div
                        style={{
                          display: "flex",
                          width: "70%",
                          flexDirection: "column",
                          alignItems: "flex-start",
                        }}
                      >
                        {matchesSearchQuery &&
                          matchesSearchQuery?.map((el) => (
                            <div
                              style={{
                                width: "100%",
                                display: "flex",
                                justifyContent: "space-between",
                                marginTop: "10px",
                              }}
                            >
                              <label
                                className="col-form-label"
                                style={{ fontSize: "15px" }}
                              >
                                {el.name}
                              </label>
                              <div style={{ width: "53%" }}>{el.input}</div>
                            </div>
                          ))}
                      </div>
                      {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2">
                        Override Receipt Title:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            type="text"
                            className="form-control"
                            id="OverrideReceiptTitle"
                            name="OverrideReceiptTitle"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                      {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2">
                        Email Receipt Subject:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            type="text"
                            className="form-control"
                            placeholder="Sales Receipt"
                            id="EmailReceiptSubject"
                            name="EmailReceiptSubject"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                      {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Show Item Id On Receipt:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="ShowItemIdOnReceipt"
                            name="ShowItemIdOnReceipt"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                      {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Show Images On Receipt:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="ShowImagesOnReceipt"
                            name="ShowImagesOnReceipt"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                      {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2">
                        Max Width Of Item Images On Receipt (Percentage):
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            as="select"
                            className="form-control form-small select"
                            id="MaxWidthOfItemImagesOnReceipt"
                            name="MaxWidthOfItemImagesOnReceipt"
                            onChange={handleChange}
                          >
                            <option>1%</option>
                            <option>2%</option>
                            <option>3%</option>
                            <option>4%</option>
                            <option>5%</option>
                            <option>10%</option>
                            <option>15%</option>
                            <option>20%</option>
                            <option>25%</option>
                            <option>30%</option>
                            <option>35%</option>
                            <option>40%</option>
                            <option>45%</option>
                            <option>50%</option>
                            <option>55%</option>
                            <option>60%</option>
                            <option>65%</option>
                            <option>70%</option>
                            <option>75%</option>
                            <option>80%</option>
                            <option>85%</option>
                            <option>90%</option>
                            <option>95%</option>
                            <option>100%</option>
                          </Field>
                        </div>
                      </div>
                    </div> */}
                      {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Show Person ID On Receipt:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="ShowPersonIDOnReceipt"
                            name="ShowPersonIDOnReceipt"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                      {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Show Item Tags On Fulfillment Sheet:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="ShowItemTagsOnFulfillmentSheet"
                            name="ShowItemTagsOnFulfillmentSheet"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                      {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Show Total On Fulfillment Sheet:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="ShowTotalOnFulfillmentSheet"
                            name="ShowTotalOnFulfillmentSheet"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                      {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Show Taxable And Non Taxable Summary On Receipt:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="ShowTaxableAndNonTaxableSummaryOnReceipt"
                            name="ShowTaxableAndNonTaxableSummaryOnReceipt"
                            onChange={handleChange}
                            onInput={
                              handleShowTaxableAndNonTaxableSummaryOnReceipt
                            }
                          />
                        </div>
                      </div>
                    </div> */}
                      {/* <div
                      className={`form-group row ${showTaxableAndNonTaxableSummaryOnReceipt === true
                        ? ""
                        : "d-none"
                        }`}
                    >
                      <label className="col-form-label col-lg-2">
                        Override Symbol For Taxable Summary On Receipt:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            type="text"
                            className="form-control"
                            id="OverrideSymbolForTaxableSummaryOnReceipt"
                            name="OverrideSymbolForTaxableSummaryOnReceipt"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                      {/* <div
                      className={`form-group row ${showTaxableAndNonTaxableSummaryOnReceipt === true
                        ? ""
                        : "d-none"
                        }`}
                    >
                      <label className="col-form-label col-lg-2">
                        Override Symbol For Non Taxable Summary On Receipt:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            type="text"
                            className="form-control"
                            id="OverrideSymbolForNonTaxableSummaryOnReceipt"
                            name="OverrideSymbolForNonTaxableSummaryOnReceipt"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                      {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Show Tax Details On Receipt:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="ShowTaxDetailsOnReceipt"
                            name="ShowTaxDetailsOnReceipt"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                      {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2">
                        Second Language On Receipts:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            as="select"
                            className="form-control form-small select"
                            id="SecondLanguageOnReceipts"
                            name="SecondLanguageOnReceipts"
                            onChange={handleChange}
                          >
                            <option>None</option>
                            <option>English</option>
                            <option>Indonesia</option>
                            <option>Española</option>
                            <option>Fançais</option>
                            <option>Italiano</option>
                            <option>Deutsch</option>
                            <option>Nederlands</option>
                            <option>Portugues</option>
                            <option>العَرَبِيةُ‎‎</option>
                            <option>Khmer</option>
                            <option>Vietnamese</option>
                            <option>中文</option>
                            <option>繁體中文</option>
                            <option>Tamil</option>
                          </Field>
                        </div>
                      </div>
                    </div> */}
                      {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Uppercase Receipt Text:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="UppercaseReceiptText"
                            name="UppercaseReceiptText"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                      {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Show Item Kit Items On Receipt:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="ShowItemKitItemsOnReceipt"
                            name="ShowItemKitItemsOnReceipt"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                      {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Show Total Discount On Receipt:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="ShowTotalDiscountOnReceipt"
                            name="ShowTotalDiscountOnReceipt"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                      {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Hide Prices On Fulfillment Sheet:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="HidePricesOnFulfillmentSheet"
                            name="HidePricesOnFulfillmentSheet"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                      {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Show Item Id On Receiving:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="ShowItemIdOnReceiving"
                            name="ShowItemIdOnReceiving"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                      {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Hide ALL Prices On Receiving:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="HideALLPricesOnReceiving"
                            name="HideALLPricesOnReceiving"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                      {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2">
                        Number Of Decimals For Quantity On Receipt:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            as="select"
                            className="form-control form-small select"
                            id="NumberOfDecimalsForQuantityOnReceipt"
                            name="NumberOfDecimalsForQuantityOnReceipt"
                            onChange={handleChange}
                          >
                            <option>Let system decide (Recommended)</option>
                            <option>0</option>
                            <option>1</option>
                            <option>2</option>
                            <option>3</option>
                            <option>4</option>
                            <option>5</option>
                            <option>6</option>
                            <option>7</option>
                            <option>8</option>
                            <option>9</option>
                            <option>10</option>
                          </Field>
                        </div>
                      </div>
                    </div> */}
                      {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Indicate Taxable On Receipt:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="IndicateTaxableOnReceipt"
                            name="IndicateTaxableOnReceipt"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                      {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Indicate Non Taxable On Receipt:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="IndicateNonTaxableOnReceipt"
                            name="IndicateNonTaxableOnReceipt"
                            onChange={handleChange}
                            onInput={handleIndicateNonTaxableOnReceipt}
                          />
                        </div>
                      </div>
                    </div> */}
                      {/* <div
                      className={`form-group row ${indicateNonTaxableOnReceipt === true ? "" : "d-none"
                        }`}
                    >
                      <label className="col-form-label col-lg-2">
                        Override Symbol For Non Taxable:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            type="text"
                            className="form-control"
                            id="OverrideSymbolForNonTaxable"
                            name="OverrideSymbolForNonTaxable"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                      {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Show Tax Per Item On Receipt:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="ShowTaxPerItemOnReceipt"
                            name="ShowTaxPerItemOnReceipt"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                      {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Hide Description On Receipt:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="HideDescriptionOnReceipt"
                            name="HideDescriptionOnReceipt"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                      {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Hide Merchant ID From Receipt:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="HideMerchantIDFromReceipt"
                            name="HideMerchantIDFromReceipt"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                      {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Hide Description On E-Mailed Receipts:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="HideDescriptionOnEMailedReceipts"
                            name="HideDescriptionOnEMailedReceipts"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                      {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Hide Description On Sales And Receivings Interfaces:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="HideDescriptionOnSalesAndReceivingsInterfaces"
                            name="HideDescriptionOnSalesAndReceivingsInterfaces"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                      {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Hide Item Description On Suspended Sales:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="HideItemDescriptionOnSuspendedSales"
                            name="HideItemDescriptionOnSuspendedSales"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                      {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Show Original Price On Receipt If Marked Down:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="ShowOriginalPriceOnReceiptIfMarkedDown"
                            name="ShowOriginalPriceOnReceiptIfMarkedDown"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                      {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Print Receipt After Sale:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="PrintReceiptAfterSale"
                            name="PrintReceiptAfterSale"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                      {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Wide Printer Receipt Format:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="WidePrinterReceiptFormat"
                            name="WidePrinterReceiptFormat"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                      {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Print Receipt After Receiving:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="PrintReceiptAfterReceiving"
                            name="PrintReceiptAfterReceiving"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                      {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Hide Signature:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="HideSignature"
                            name="HideSignature"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                      {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Disable Signature Capture For PHP POS Credit Card
                        Processing:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="DisableSignatureCaptureForPHPPOSCreditCardProcessing"
                            name="DisableSignatureCaptureForPHPPOSCreditCardProcessing"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                      {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Auto Capture Signature:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="AutoCaptureSignature"
                            name="AutoCaptureSignature"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                      {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Remove Customer Name From Receipt:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="RemoveCustomerNameFromReceipt"
                            name="RemoveCustomerNameFromReceipt"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                      {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Remove Employee Last Name From Receipt:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="RemoveEmployeeLastNameFromReceipt"
                            name="RemoveEmployeeLastNameFromReceipt"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                      {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Remove Employee Name From Receipt:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="RemoveEmployeeNameFromReceipt"
                            name="RemoveEmployeeNameFromReceipt"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                      {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Remove Customer Company Name From Receipt:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="RemoveCustomerCompanyNameFromReceipt"
                            name="RemoveCustomerCompanyNameFromReceipt"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                      {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Remove Customer Contact Info From Receipt:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="RemoveCustomerContactInfoFromReceip"
                            name="RemoveCustomerContactInfoFromReceip"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                      {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Hide E-Mail On Receipt:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="HideEMailOnReceipt"
                            name="HideEMailOnReceipt"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                      {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2">
                        Sort Receipt Column:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            as="select"
                            className="form-control form-small select"
                            id="SortReceiptColumn"
                            name="SortReceiptColumn"
                            onChange={handleChange}
                          >
                            <option>Node</option>
                            <option>Item Name</option>
                            <option>UPC/EAN/ISBN</option>
                            <option>Product ID</option>
                          </Field>
                        </div>
                      </div>
                    </div> */}
                      {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Automatically Email Receipt:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="AutomaticallyEmailReceipt"
                            name="AutomaticallyEmailReceipt"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                      {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Automatically SMS Receipt:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="AutomaticallySMSReceipt"
                            name="AutomaticallySMSReceipt"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                      {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Automatically Print Duplicate Receipt For Credit Card
                        Transactions:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="AutomaticallyPrintDuplicateReceiptForCreditCardTransactions"
                            name="AutomaticallyPrintDuplicateReceiptForCreditCardTransactions"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                      {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Always Print Duplicate Receipt For All Transactions:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="AlwaysPrintDuplicateReceiptForAllTransactions"
                            name="AlwaysPrintDuplicateReceiptForAllTransactions"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                      {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Automatically Show Comments On Receipt:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="AutomaticallyShowCommentsOnReceipt"
                            name="AutomaticallyShowCommentsOnReceipt"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                      {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Hide Barcode On Receipts:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="HideBarcodeOnReceipts"
                            name="HideBarcodeOnReceipts"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                      {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Group All Taxes On Receipt:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="GroupAllTaxesOnReceipt"
                            name="GroupAllTaxesOnReceipt"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                      {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Redirect To Sale Or Receiving Screen After Printing
                        Receipt:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="RedirectToSaleOrReceivingScreenAfterPrintingReceipt"
                            name="RedirectToSaleOrReceivingScreenAfterPrintingReceipt"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                      {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2">
                        Receipt Text Size:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            as="select"
                            className="form-control form-small select"
                            id="ReceiptTextSize"
                            name="ReceiptTextSize"
                            onChange={handleChange}
                          >
                            <option>Small</option>
                            <option>Medium</option>
                            <option>Large</option>
                            <option>Extra Large</option>
                          </Field>
                        </div>
                      </div>
                    </div> */}
                      {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Hide Store Account Balance On Receipt:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="HideStoreAccountBalanceOnReceipt"
                            name="HideStoreAccountBalanceOnReceipt"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                      {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Round To Nearest .05 On Receipt:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="RoundToNearest05OnReceipt"
                            name="RoundToNearest05OnReceipt"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                      {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2">
                        Return Policy:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            as="textarea"
                            className="form-control"
                            rows={3}
                            id="ReturnPolicy"
                            name="ReturnPolicy"
                            onChange={handleChange}
                          ></Field>
                        </div>
                      </div>
                    </div> */}
                      {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2">
                        Announcements/Specials:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            as="textarea"
                            type="text"
                            className="form-control"
                            rows={3}
                            id="AnnouncementsSpecials"
                            name="AnnouncementsSpecials"
                            onChange={handleChange}
                          ></Field>
                        </div>
                      </div>
                    </div> */}
                      {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Enable PDF Receipts:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="EnablePDFReceipts"
                            name="EnablePDFReceipts"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                      {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2">
                        PDF Receipt Message In Email Body:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            as="textarea"
                            type="text"
                            className="form-control"
                            rows={3}
                            id="PDFReceiptMessageInEmailBody"
                            name="PDFReceiptMessageInEmailBody"
                            onChange={handleChange}
                          ></Field>
                        </div>
                      </div>
                    </div> */}
                      {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Show Signature On Receiving Receipt:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="ShowSignatureOnReceivingReceipt"
                            name="ShowSignatureOnReceivingReceipt"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                      {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2">
                        Override Signature Text:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            as="textarea"
                            type="text"
                            className="form-control"
                            rows={3}
                            id="OverrideSignatureText"
                            name="OverrideSignatureText"
                            onChange={handleChange}
                          ></Field>
                        </div>
                      </div>
                    </div> */}
                      {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Hide Categories On Receivings Grid:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="HideCategoriesOnReceivingsGrid"
                            name="HideCategoriesOnReceivingsGrid"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                      {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Hide Tags On Receivings Grid:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="HideTagsOnReceivingsGrid"
                            name="HideTagsOnReceivingsGrid"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                      {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Hide Suppliers On Receivings Grid:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="HideSuppliersOnReceivingsGrid"
                            name="HideSuppliersOnReceivingsGrid"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                      {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Hide Favorites On Receivings Grid:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="HideFavoritesOnReceivingsGrid"
                            name="HideFavoritesOnReceivingsGrid"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                      {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2">
                        Receipt Download Filename Prefix:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            type="text"
                            className="form-control"
                            id="ReceiptDownloadFilenamePrefix"
                            name="ReceiptDownloadFilenamePrefix"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                      {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Capture Internal Notes During Receiving:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="CaptureInternalNotesDuringReceiving"
                            name="CaptureInternalNotesDuringReceiving"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                      {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Disable Variation Popup In Receiving:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="DisableVariationPopupInReceiving"
                            name="DisableVariationPopupInReceiving"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                      {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Hide Location Name On Receipt:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="HideLocationNameOnReceipt"
                            name="HideLocationNameOnReceipt"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                      {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Allow Reorder On Sales Receipt:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="AllowReorderOnSalesReceipt"
                            name="AllowReorderOnSalesReceipt"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                      {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Allow Reorder On Receiving Receipt:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="AllowReorderOnReceivingReceipt"
                            name="AllowReorderOnReceivingReceipt"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                      <button
                        type="submit"
                        className="btn btn-primary pull-right mb-3"
                      >
                        Save
                      </button>
                    </Form>
                  )}
                </Formik>
              </div>
            </CCollapse>
          </div>
        )
      )}
    </>
  );
};

export default Receipt;
